import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MainGrid = styled(Grid)({
  background: '#FAFAFA',
  display: 'flex',
  width: '100vw',
  height: '100vh'
});
